"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromSelectField = exports.SelectDef = void 0;
const tslib_1 = require("tslib");
const fp_ts_1 = require("fp-ts");
const function_1 = require("fp-ts/lib/function");
const t = tslib_1.__importStar(require("io-ts"));
const utils_1 = require("../../utils");
const SelectDefType = "Select";
const codec = t.strict({
    select: t.string,
    config: t.strict({
        options: t.readonlyArray(t.string),
    }),
});
exports.SelectDef = new t.Type("SelectDef", (u) => (0, utils_1.isFieldDef)(u) && u.def.type === SelectDefType, (u) => {
    return (0, function_1.pipe)(codec.decode(u), fp_ts_1.either.map(({ select, config }) => ({
        key: select,
        def: {
            type: SelectDefType,
            config,
        },
    })));
}, (n) => n);
function fromSelectField(def) {
    var _a;
    return {
        type: SelectDefType,
        config: {
            options: ((_a = def.config) === null || _a === void 0 ? void 0 : _a.options) || [],
        },
    };
}
exports.fromSelectField = fromSelectField;
